"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccounts = getAccounts;
exports.getAccountsRequestStatus = getAccountsRequestStatus;
exports.setPinnedAccounts = setPinnedAccounts;
exports.getAnalytics = getAnalytics;
exports.getAnalyticsRequestStatus = getAnalyticsRequestStatus;

var _Raven = _interopRequireDefault(require("Raven"));

var _API = _interopRequireDefault(require("./API"));

var _immutable = require("immutable");

var _RequestStatusTypes = _interopRequireDefault(require("hub-pickers-lib/constants/RequestStatusTypes"));

var _Account = _interopRequireDefault(require("./records/Account"));

var _Analytics = _interopRequireDefault(require("./records/Analytics"));

var _sorts = require("../utils/sorts");

var accounts = null;
var pinnedAccounts = null;
var analytics = null;
var lastAnalyticsPeriod = null;
var hubsFailedToLoad = false;
var accountsRequestStatus = _RequestStatusTypes.default.UNINITIALIZED;
var analyticsRequestStatus = _RequestStatusTypes.default.UNINITIALIZED;

function getAccounts() {
  var includePins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var includeStats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!accounts) {
    accountsRequestStatus = _RequestStatusTypes.default.PENDING;
    return _API.default.getAccounts(includePins, includeStats).then(function (payload) {
      accountsRequestStatus = _RequestStatusTypes.default.SUCCEEDED;
      accounts = (0, _immutable.List)(payload.accounts.map(function (account) {
        return (0, _Account.default)(account).set('products', (0, _immutable.Set)(account.products));
      })).sort((0, _sorts.sortByField)('accountName'));
      pinnedAccounts = (0, _immutable.List)(payload.pinnedAccountIds);
      hubsFailedToLoad = payload.hubsFailedToLoad;

      if (accounts.size === 0) {
        _Raven.default.captureMessage('Received empty list of accounts');
      }

      return {
        accounts: accounts,
        pinnedAccounts: pinnedAccounts,
        accountsRequestStatus: accountsRequestStatus,
        hubsFailedToLoad: hubsFailedToLoad
      };
    }).catch(function (error) {
      _Raven.default.captureException(error);

      accountsRequestStatus = _RequestStatusTypes.default.FAILED;
      accounts = (0, _immutable.List)();
      return {
        accounts: accounts,
        accountsRequestStatus: accountsRequestStatus
      };
    });
  }

  return Promise.resolve({
    accounts: accounts,
    accountsRequestStatus: accountsRequestStatus
  });
}

function getAccountsRequestStatus() {
  return accountsRequestStatus;
}

function setPinnedAccounts(updatedPinnedAccounts) {
  return _API.default.setPinnedAccounts(updatedPinnedAccounts).then(function (payload) {
    pinnedAccounts = (0, _immutable.List)(payload);
    return pinnedAccounts;
  });
}

function getAnalytics(analyticsPeriod) {
  if (!analytics || analyticsPeriod !== lastAnalyticsPeriod) {
    lastAnalyticsPeriod = analyticsPeriod;
    analyticsRequestStatus = _RequestStatusTypes.default.PENDING;
    return _API.default.getAnalytics(analyticsPeriod).then(function (payload) {
      analyticsRequestStatus = _RequestStatusTypes.default.SUCCEEDED;
      analytics = (0, _immutable.Map)(payload.analytics).map(function (account) {
        var _account$totals = account.totals,
            currentPeriodSessions = _account$totals.currentPeriodSessions,
            previousPeriodSessions = _account$totals.previousPeriodSessions,
            currentPeriodLeads = _account$totals.currentPeriodLeads,
            previousPeriodLeads = _account$totals.previousPeriodLeads;

        if (currentPeriodSessions && previousPeriodSessions) {
          var changeInSessions = ((currentPeriodSessions - previousPeriodSessions) / previousPeriodSessions * 100.0).toFixed(2);
          account.changeInSessions = changeInSessions;
        }

        if (currentPeriodLeads && previousPeriodLeads) {
          var changeInLeads = ((currentPeriodLeads - previousPeriodLeads) / previousPeriodLeads * 100.0).toFixed(2);
          account.changeInLeads = changeInLeads;
        }

        return new _Analytics.default(account);
      });
      return {
        analytics: analytics,
        analyticsRequestStatus: analyticsRequestStatus
      };
    }).catch(function (error) {
      _Raven.default.captureException(error);

      analyticsRequestStatus = _RequestStatusTypes.default.FAILED;
      analytics = (0, _immutable.Map)();
      return {
        analytics: analytics,
        analyticsRequestStatus: analyticsRequestStatus
      };
    });
  }

  return Promise.resolve({
    analytics: analytics,
    analyticsRequestStatus: analyticsRequestStatus
  });
}

function getAnalyticsRequestStatus() {
  return analyticsRequestStatus;
}